module.exports = __webpack_public_path__ + "static/media/advertencia3.7e525650.PNG";